module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"days":"Tage","hours":"Std.","minutes":"Min.","seconds":"Sek."},"en":{"days":"days","hours":"hours","minutes":"min.","seconds":"sec."}}')
  delete Component.options._Ctor
}
